import React from 'react';
import { connect } from 'react-redux';
import { SettingsDialog, _connect } from './SettingsDialog';
import { IconClose, IconDevices } from '../../../base/icons';
import { DialogWithTabs } from '../../../base/dialog';

class RPC_SettingsDialog extends SettingsDialog {

    constructor(props) {
        super(props);
        this._customHeader = this._customHeader.bind(this);
    }

    _customHeader() {
        return (
            <header>
                <h4>
                    <IconDevices />
                    <span id="dialog-heading-1">Devices</span>
                </h4>
                <div className="jitsi-icon" onClick={ this._closeDialog }>
                    <IconClose />
                </div>
            </header>
        )
    }

    render() {
        const { _tabs, defaultTab, dispatch } = this.props;
        const onSubmit = this._closeDialog;
        const defaultTabIdx
            = _tabs.findIndex(({ name }) => name === defaultTab);
        const tabs = _tabs.map(tab => {
            return {
                ...tab,
                onMount: tab.onMount
                    ? (...args) => dispatch(tab.onMount(...args))
                    : undefined,
                submit: (...args) => tab.submit
                    && dispatch(tab.submit(...args))
            };
        });

        return (
            <DialogWithTabs
                closeDialog = { this._closeDialog }
                cssClassName = 'settings-dialog'
                defaultTab = {
                    defaultTabIdx === -1 ? undefined : defaultTabIdx
                }
                onSubmit = { onSubmit }
                tabs = { tabs }
                titleKey = 'settings.title'
                hideCancelButton = { true }
                okKey = { "Done" }
                customHeader = { this._customHeader }
            />
        );
    }
}

function _mapStateToProps(state, ownProps) {
    return { _tabs: [ownProps._tabs[0]]};
}

export default _connect(connect(_mapStateToProps)(RPC_SettingsDialog));